"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require("react");
var ReactDOM = require("react-dom");
var input_form_1 = require("./components/input-form");
var session_1 = require("./session");
var env_1 = require("./env");
var VALIDATE_TYPE = input_form_1.default.VALIDATE_TYPE;
var ERROR_MESSAGE_TYPE = input_form_1.default.ERROR_MESSAGE_TYPE;
/*
 * ログインフォームコンポーネント
 */
var Login = (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super.call(this) || this;
        _this.data = {
            message: 'ログイン',
            links: [
                { href: 'forgotPassword.html', linkText: 'パスワードをお忘れですか？' },
                { href: 'register.html', linkText: 'はじめてログインする方はこちら' },
            ],
            inputTexts: [
                {
                    label: 'Eメールアドレス',
                    name: 'email',
                    value: '',
                    type: 'email',
                    icon: 'glyphicon glyphicon-envelope',
                    setValue: function (value) {
                        _this.setValue('email', value.trim());
                        _this.validate('email', [VALIDATE_TYPE.EXIST]);
                    },
                },
                {
                    label: 'パスワード',
                    name: 'password',
                    value: '',
                    type: 'password',
                    icon: 'glyphicon glyphicon-lock',
                    setValue: function (value) {
                        _this.setValue('password', value);
                        _this.validate('password', [VALIDATE_TYPE.EXIST]);
                    },
                },
            ],
            buttons: [
                {
                    name: 'dummy',
                    text: '',
                    size: '8',
                },
                {
                    name: 'ok',
                    text: 'ログイン',
                    size: '4',
                    call: function () {
                        _this.validate('email', [VALIDATE_TYPE.EXIST]);
                        _this.validate('password', [VALIDATE_TYPE.EXIST]);
                        /*
                        直接this.stateを呼ぶと最新の値が取れない場合があるので、
                        setStaetのコールバックに渡される値を利用する。
                        https://facebook.github.io/react/docs/react-component.html#setstate
                        */
                        _this.setState(function (state) {
                            if (state.processing) {
                                return state;
                            }
                            var hasError = false;
                            for (var key in state.inputTexts) {
                                if (state.inputTexts[key].errorMessage) {
                                    hasError = true;
                                }
                            }
                            if (hasError) {
                                state.errorMessage = {
                                    text: 'エラーとなっている項目をご確認ください。',
                                    type: ERROR_MESSAGE_TYPE.VALIDATE,
                                };
                                return state;
                            }
                            var userName = state.inputTexts.email.value;
                            var password = state.inputTexts.password.value;
                            var session = _this.session;
                            session.create(userName, password).then(function () {
                                window.location.href = 'accessCount.html';
                            }).catch(function (reason) {
                                _this.setState(function (s) {
                                    s.errorMessage = {
                                        text: reason.message, type: ERROR_MESSAGE_TYPE.SERVER,
                                    };
                                    s.processing = false;
                                    return s;
                                });
                            });
                            state.processing = true;
                            return state;
                        });
                    },
                },
            ],
        };
        _this.session = null;
        _this.session = new session_1.default.Client(env_1.default.ConnectSetting);
        _this.state = {
            inputTexts: _this.data.inputTexts.reduce(function (obj, inputText) {
                obj[inputText.name] = {
                    label: inputText.label,
                    value: inputText.value,
                    errorMessage: inputText.errorMessage,
                };
                return obj;
            }, { email: null, password: null }),
            errorMessage: _this.data.errorMessage,
            processing: false,
        };
        return _this;
    }
    return Login;
}(input_form_1.default.InputForm));
ReactDOM.render(React.createElement(Login, null), document.getElementById('login'));



//////////////////
// WEBPACK FOOTER
// ./build/js/login.js
// module id = 0
// module chunks = 2